module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sku__item",
    class: {
      'sku__item--invisible': !_vm.imgLoaded
    }
  }, [_c('router-link', {
    staticClass: "inner",
    attrs: {
      "to": _vm.routerTo()
    }
  }, [(_vm.product.images.length > 0) ? _c('img', {
    attrs: {
      "src": _vm.shopifyImg(_vm.product.images[0].src),
      "alt": _vm.product.title
    },
    on: {
      "load": function($event) {
        _vm.imgLoaded = true
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "h7 uppercase"
  }, [_c('label', [_c('div', [_c('span', [_vm._v(_vm._s(_vm.product.title))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.product.variants[0].formattedPrice))])])]), _vm._v(" "), _c('button', {
    staticClass: "view-item-btn"
  }, [_c('span', [_vm._v("Purchase Item")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1579641a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Collection__SKUs__Item.vue
// module id = 375
// module chunks = 1